import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import workStyle from "assets/jss/material-kit-pro-react/views/landingPageSections/workStyle.jsx";
import TranslationService from "../../../services/translation/TransationService";
import ApiClient from "../../../services/api-client/ApiClient";
import { EmailValidator } from "../../../services/validators/email";

class SectionWork extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      nameError: false,
      email: "",
      emailError: false,
      message: "",
      messageError: false,
      hasBeenSubmitted: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateName = this.validateName.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.validateMessage = this.validateMessage.bind(this);
  }

  handleChange(event) {
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  }

  validateName() {
    if (!this.state.name) {
      this.setState({ ...this.state, nameError: true });
      return;
    }
    this.setState({
      ...this.state,
      nameError: false
    });
  }

  validateEmail() {
    const emailValidation = EmailValidator.validateEmail(this.state.email);

    if (!emailValidation) {
      this.setState({ ...this.state, emailError: true });
      return;
    }

    this.setState({
      ...this.state,
      emailError: false
    });
  }

  validateMessage() {
    if (!this.state.message) {
      this.setState({ ...this.state, messageError: true });
      return;
    }
    this.setState({
      ...this.state,
      messageError: false
    });
  }

  validateFields() {
    this.validateName();
    this.validateEmail();
    this.validateMessage();
  }

  handleSubmit(event) {
    this.validateFields();

    if (
      this.state.nameError ||
      this.state.emailError ||
      this.state.messageError
    ) {
      return;
    }

    ApiClient.feedback
      .create({
        name: this.state.name,
        email: this.state.email,
        message: this.state.message
      })
      .then(() => {
        this.setState({
          name: "",
          email: "",
          message: "",
          hasBeenSubmitted: true
        });
      });
    event.preventDefault();
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section} id="opinion">
        <GridContainer justify="center">
          <GridItem cs={12} sm={8} md={8}>
            <h2 className={classes.title}>
              {TranslationService.get("OPINION.TITLE")}
            </h2>
            <h4 className={classes.description}>
              {TranslationService.get("OPINION.CONTENT")}
            </h4>
            <form onSubmit={this.handleSubmit}>
              <GridContainer>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText={TranslationService.get("OPINION.FORM.NAME")}
                    id="name"
                    type="text"
                    formControlProps={{
                      fullWidth: true,
                      required: true,
                      error: this.state.nameError
                    }}
                    inputProps={{
                      value: this.state.name,
                      onChange: this.handleChange,
                      onBlur: this.validateName,
                      name: "name"
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText={TranslationService.get("OPINION.FORM.EMAIL")}
                    id="email"
                    type="email"
                    formControlProps={{
                      fullWidth: true,
                      required: true,
                      error: this.state.emailError
                    }}
                    inputProps={{
                      value: this.state.email,
                      onChange: this.handleChange,
                      onBlur: this.validateEmail,
                      name: "email"
                    }}
                  />
                </GridItem>
                <CustomInput
                  labelText={TranslationService.get("OPINION.FORM.MESSAGE")}
                  id="message"
                  type="text"
                  name="message"
                  formControlProps={{
                    fullWidth: true,
                    className: classes.textArea,
                    required: true,
                    error: this.state.messageError
                  }}
                  inputProps={{
                    multiline: true,
                    rows: 5,
                    value: this.state.message,
                    onChange: this.handleChange,
                    onBlur: this.validateMessage,
                    name: "message"
                  }}
                />
                <GridItem
                  xs={12}
                  sm={4}
                  md={4}
                  className={`${classes.mrAuto} ${classes.mlAuto}`}
                  style={{ textAlign: "center" }}
                >
                  <Button color="warning" type="submit">
                    {TranslationService.get("OPINION.FORM.SUBMIT")}
                  </Button>
                </GridItem>
              </GridContainer>
            </form>
          </GridItem>
          {this.state.hasBeenSubmitted ? (
            <GridItem cs={12} sm={8} md={8}>
              <h4 className={classes.description}>
                {TranslationService.get("OPINION.FEEDBACK")}
              </h4>
            </GridItem>
          ) : null}
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(workStyle)(SectionWork);



// WEBPACK FOOTER //
// ./src/views/QxQPublicPage/Sections/SectionWork.jsx